module.exports = __webpack_public_path__ + "assets/img/nogrid-logo-small.9c05c1ef.png";